import React, { useId, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

// Labeled input with inline error + a11y wiring (htmlFor, aria-invalid,
// aria-describedby). Pass `label`, optional `error`, and native input props.
// When type="password", a show/hide toggle is rendered automatically.
// `endAdornment` renders an extra button inside the box's right edge (same
// slot/positioning as the password toggle) — e.g. an "insert special
// character" trigger.
export default function Input({ label, id, error, className = '', type = 'text', endAdornment, ...rest }) {
  const autoId = useId();
  const inputId = id || autoId;
  const errorId = `${inputId}-error`;

  const isPassword = type === 'password';
  const [revealed, setRevealed] = useState(false);
  const effectiveType = isPassword && revealed ? 'text' : type;

  const inputEl = (
    <input
      id={inputId}
      type={effectiveType}
      className={`ss-input ${error ? 'ss-input--error' : ''} ${className}`.trim()}
      aria-invalid={error ? 'true' : undefined}
      aria-describedby={error ? errorId : undefined}
      {...rest}
    />
  );

  return (
    <div className="ss-field">
      {label && (
        <label htmlFor={inputId} className="ss-label">
          {label}
        </label>
      )}

      {isPassword || endAdornment ? (
        <div className="ss-input-wrap">
          {inputEl}
          {isPassword && (
            <button
              type="button"
              className="ss-input-reveal"
              aria-label={revealed ? 'Hide password' : 'Show password'}
              aria-pressed={revealed}
              onClick={() => setRevealed((v) => !v)}
            >
              {revealed ? <EyeOff size={18} aria-hidden="true" /> : <Eye size={18} aria-hidden="true" />}
            </button>
          )}
          {endAdornment}
        </div>
      ) : (
        inputEl
      )}

      {error && (
        <p id={errorId} className="ss-field__error">
          {error}
        </p>
      )}
    </div>
  );
}
